// extracted by mini-css-extract-plugin
module.exports = {"icon":"AutoApprovedStrip_icon__1OK2w","text":"AutoApprovedStrip_text__N4Pfu","container":"AutoApprovedStrip_container__1qNVL"};